import ACTIONS from "../../constants/actions";

export const setTracker = (trackerId) => dispatch => {
	dispatch({type      : ACTIONS.TRACKER.SET, trackerId : trackerId});
};


export const toggleTracker = () => dispatch => {
	dispatch({type      : ACTIONS.TRACKER.TOGGLE,})
};




// WEBPACK FOOTER //
// ./src/app/redux/actions/tracker.js